export const LAYOUT = {
  sidenavLogoUrl: 'assets/img/logo/logo-partners.svg',
  sidenavCollapsedLogoUrl: 'assets/img/logo/logo-monogram.svg',
  toolbarLogoUrl: 'assets/img/logo/logo-partners-line.svg',
  sidenavUserVisible: true,
  footerVisible: false,
} as const;
